"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savedDepartureDTO = void 0;

var _DTOError = _interopRequireDefault(require("../../../errors/DTOError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * DTO, которая парсит данные для ручки отображения цен
 */
var savedDepartureDTO = function savedDepartureDTO(data) {
  if (data && _typeof(data) === 'object' && 'id' in data && typeof data.id === 'number' && 'iso2' in data && typeof data.iso2 === 'string' && 'label' in data && typeof data.label === 'string' && 'value' in data && typeof data.value === 'string' && 'selectedLabel' in data && typeof data.selectedLabel === 'string') {
    return {
      id: data.id,
      iso2: data.iso2,
      label: data.label,
      value: data.value,
      selectedLabel: data.selectedLabel,
      isAutomaticallyDetected: 'isAutomaticallyDetected' in data && typeof data.isAutomaticallyDetected === 'boolean' ? data.isAutomaticallyDetected : undefined,
      description: 'description' in data && typeof data.description === 'string' ? data.description : undefined,
      distance: 'distance' in data && typeof data.distance === 'number' ? data.distance : undefined
    };
  }

  throw new _DTOError["default"]('savedDepartureDTO', data);
};

exports.savedDepartureDTO = savedDepartureDTO;